export enum EnrollmentTypes {
  Opportunity = 1,
  LoyaltyProgramEnrolled = 2,
  LoyaltyProgramDeclined = 4,
  LoyaltyProgramExisting = 8,
  AssignedToLocation = 16,
  AssignedToMerchant = 32,
  MissedOpportunity = 64,
  CanceledEnrollment = 128,
  NoLongerMember = 256,
  AssignedToCoalition = 512,
}
